import React, { useMemo } from 'react';
import { startOfMonth, endOfMonth, fmtDateISO, safeParseDate, withinRange, monthName } from '../utils';

export default function MonthHeat({ monthDate, activities }) {
  const start = startOfMonth(monthDate);
  const end = endOfMonth(monthDate);
  const dayCounts = useMemo(() => {
    const map = new Map();
    activities.forEach((a) => {
      const d = safeParseDate(a.at);
      if (!withinRange(d, start, end)) return;
      const key = fmtDateISO(new Date(d.getFullYear(), d.getMonth(), d.getDate()));
      map.set(key, (map.get(key) || 0) + 1);
    });
    return map;
  }, [activities, start.getTime(), end.getTime()]);
  const max = Math.max(1, ...Array.from(dayCounts.values()));
  return (
    <div className="heat">
      <div className="heatTop">
        <div className="heatTitle">Month Activity</div>
        <div className="heatMeta">
          <span className="muted">{monthName(monthDate.getMonth())}</span>
          <span className="sep">•</span>
          <span className="muted">max/day {max}</span>
        </div>
      </div>
      <div className="heatGrid" role="img" aria-label="Monthly activity heatmap">
        {Array.from({ length: 31 }).map((_, i) => {
          const dd = new Date(monthDate.getFullYear(), monthDate.getMonth(), i + 1);
          if (dd.getMonth() !== monthDate.getMonth()) return <span key={i} className="heatCell heatOff" />;
          const key = fmtDateISO(dd);
          const v = dayCounts.get(key) || 0;
          const t = v / max;
          return <span key={i} className="heatCell" style={{ opacity: 0.25 + t * 0.75 }} title={`${key}: ${v}`} />;
        })}
      </div>
      <div className="heatLegend">
        <span className="muted">low</span>
        <span className="heatBar" />
        <span className="muted">high</span>
      </div>
    </div>
  );
}
